module.exports = __webpack_public_path__ + "static/media/ipad.2aafe0dd.png";